<template>
	<div>
		<!-- USUARIO SOLICITUDES  -->
		<div v-if="solicitudesDisponibles.length" >
			<simple-card v-for="solicitud in solicitudesDisponibles" v-bind:key="solicitud.id" v-bind:cardInfo="solicitud" />
		</div>
		<div v-else>	
			<ion-item lines="none">
				<h4> No cuentas con ninguna solicitud reciente</h4>
			</ion-item>
		</div>
		<br/>
		<ion-fab @click="showConsole()" horizontal="end" vertical="bottom" slot="fixed">
			<ion-fab-button color="danger">
				<ion-icon name="add"></ion-icon>
			</ion-fab-button>
		</ion-fab>
		<!-- <card-img /> -->
		<!-- <float-btn/> -->
	</div>
</template>
<style lang="scss">
ion-fab{
	position: absolute;
	left: 85%;
	bottom: 30px;	
}
</style>
<script>
	import firebase from '../config'
	// import Push from 'push.js'
	// import CardImg from '../components/CardImg.vue'
	import SimpleCard from '../components/SimpleCard'
	// import FloatBtn from '../components/FloatBtn.vue'
	// const dbTodos = firebase.database().ref('todos');
	// const allTodos = db.collection('todos')
	const { db } = firebase;
	export default {
		name: "LevantekSolicitudes",
		components: { SimpleCard  },
			data() {
				return {
					solicitudesDisponibles:[],
					publicPath: process.env.BASE_URL,
					info: null
				};
			},
		firestore: {
				// solicitudesDisponibles: db.collection('todos'),
			},
		methods: {
    showConsole() {
      this.$router.push('nueva-solicitud');
    },
			// reRedirect() {
			// 	if(  this.re.rol == "1ib87WwHClPfwbCJS8BB")
			// 		this.$router.replace('/solicitudes-admin')
			// 	else if( this.re.rol == "jcwXkDPT9SzhJJd179Sr")
			// 		this.$router.replace('/solicitudes')
			// 	// else
			// 	// 	this.$router.replace('/solicitudes-admin')
			// },
			openStart () {
				document.querySelector('ion-menu-controller').open();
        document.querySelector('ion-menu').open('my-menu');
				// console.log("Erroro");

			},
			openEnd () {
				document.querySelector('ion-menu').open('end')
			},
			// async getZipInfo(zip) {
			// 	const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
			// 	if (res.status == 404) {
			// 		this.showAlert();
			// 	}
			// 	this.info = await res.json();
			// },
			clearInfo() {
				this.info = null;
			},
			showAlert(tit, msg) {
				return this.$ionic.alertController
					.create({
						header: tit,
						message: msg,
						buttons: ["OK"]
					})
					.then(a => a.present());
			},
		},
		mounted () {
			// var promise = Push.create('Hello World!');
			// promise.then(function(notification) {
			// 	notification.close();
			// });
		},
		created () {
			let _self = this;
			let _info = _self.$storage.get("user-info");
			let u_id = _info.uuid;

			let solicitudes = [];

      // .where('finsihHim', '==', false )
      db.collection('todos')
      .where('createdBy', '==', u_id )
			.onSnapshot(function(snapshot) {
				solicitudes = [];
				snapshot.forEach(function(doc) {
            let _tpm = doc.data();
						_tpm.id  = doc.id;
						if( _tpm.finsihHim == false){
							solicitudes.push(_tpm);
						}
            // _self.re.id  = doc.id;
					});
					_self.solicitudesDisponibles =  solicitudes ;
					// console.log(solicitudes);
			}, function(error) { console.log(error); });
		// 	let isLogin = this.$storage.get("user-info");
		// 	console.log(isLogin);
		// 	if( ! isLogin == null )
		// 		this.reRedirect();
		}
	};
</script>